module.exports = __webpack_public_path__ + "img/coloredeer-logo.69f4cf9b.jpg";